var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTableTennisGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "35px",
    height: "35px",
    viewBox: "0 0 35 35",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.000000, 4.000000)",
    stroke: "#727272",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.795619,16.3459479 C26.8495467,12.0718147 26.7577709,6.29338375 23.3487431,2.75323954 C19.5613679,-1.1798048 13.1138158,-0.860942015 8.94772981,3.46537751 C5.83657292,6.69619428 4.87802346,11.2478966 6.16932522,14.9840433 C6.59695004,16.2212154 6.30717004,17.6017065 5.412157,18.5311431 L0.189354948,23.9548217 C-0.0631181652,24.2170068 -0.0631181652,24.6421576 0.189354948,24.9043405 L2.01805511,26.8033758 C2.27052834,27.0655587 2.67993225,27.0655587 2.93240548,26.8033758 L8.15520753,21.379695 C9.05019259,20.4502875 10.3795543,20.1493621 11.5708773,20.5933478 C13.8194483,21.4314151 16.3748618,21.3569014 18.7347755,20.3943915"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.51878741,
    y1: 9.87449382,
    x2: 16.4910881,
    y2: 21.2688043
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.0316734,
    cy: 19.3572974,
    rx: 3.39130435,
    ry: 3.52173913
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableTennisGrey);
export default __webpack_public_path__ + "static/media/tableTennisGrey.bb14d4eb29270be407438523ba679431.svg";
export { ForwardRef as ReactComponent };